import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getUsers = async () => {
  const response = await axios.get(`${base_url}user/all-users`);
  return response.data;
};

const createLead = async (leadData) => {
  const response = await axios.post(`${base_url}crm/lead`, leadData);
  return response.data;
};

const getLeads = async () => {
  const response = await axios.get(`${base_url}crm/leads`);
  return response.data;
};

const getLeadById = async (id) => {
  const response = await axios.get(`${base_url}crm/lead/${id}`);
  return response.data;
};

const updateLeadStatus = async ({ id, status }) => {
  const response = await axios.put(`${base_url}crm/lead/${id}`, { status });
  return response.data;
};

/* ================= FACEBOOK LEADS ================= */

const getFacebookLeadForms = async () => {
  const response = await axios.get(`${base_url}crm/facebook/forms`);
  return response.data;
};

const getSingleFacebookLeadForm = async (formId) => {
  const response = await axios.get(`${base_url}crm/facebook/forms/${formId}`);
  return response.data;
};

const getFacebookFormLeads = async (formId) => {
  const response = await axios.get(`${base_url}crm/facebook/forms/${formId}/leads`);
  return response.data;
};

/* ================= CAMPAIGNS ================= */

const getActiveCampaigns = async () => {
  const response = await axios.get(`${base_url}crm/campaigns/active`);
  return response.data;
};

const getCampaignInsights = async () => {
  const response = await axios.get(`${base_url}crm/campaigns/insights`);
  return response.data;
};

/* ================= WHATSAPP ================= */

const getAgentWhatsappChats = async ( ) => {
  const response = await axios.get(
    `${base_url}crm/whatsapp/agent/chats`);
  return response.data;
};

const sendWhatsappMessageFromCRM = async (messageData) => {
  const response = await axios.post(
    `${base_url}crm/whatsapp/send`,
    messageData
  );
  return response.data;
};

const sendWhatsappImageFromCRM = async (imageData) => {
  const response = await axios.post(
    `${base_url}crm/whatsapp/send-image`,
    imageData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

const getWhatsappChats = async () => {
  const response = await axios.get(`${base_url}crm/whatsapp/chats`);
  return response.data;
};

const getWhatsappMessagesByPhone = async (phone) => {
  const response = await axios.get(`${base_url}crm/whatsapp/messages/${phone}`);
  return response.data;
};

const customerService = {
  getUsers,
  createLead,
  getLeads,
  getLeadById,
  updateLeadStatus,
  getFacebookLeadForms,
  getSingleFacebookLeadForm,
  getFacebookFormLeads,
  getActiveCampaigns,
  getCampaignInsights,
  sendWhatsappMessageFromCRM,
  sendWhatsappImageFromCRM,
  getWhatsappChats,
  getWhatsappMessagesByPhone,
  getAgentWhatsappChats,
};

export default customerService;